import { createContext, useContext, useEffect, useState } from "react";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [sensoryFriendly, setSensoryFriendly] = useState(
    () => localStorage.getItem("im_sensory") !== "false" // default ON
  );
  const [plainLanguage, setPlainLanguage] = useState(
    () => localStorage.getItem("im_plain") === "true"
  );

  useEffect(() => {
    document.body.classList.toggle("sensory-friendly", sensoryFriendly);
    localStorage.setItem("im_sensory", String(sensoryFriendly));
  }, [sensoryFriendly]);

  useEffect(() => {
    document.body.classList.toggle("plain-language", plainLanguage);
    localStorage.setItem("im_plain", String(plainLanguage));
  }, [plainLanguage]);

  return (
    <SettingsContext.Provider
      value={{
        sensoryFriendly,
        plainLanguage,
        toggleSensory: () => setSensoryFriendly((v) => !v),
        togglePlain: () => setPlainLanguage((v) => !v),
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
